// extracted by mini-css-extract-plugin
module.exports = {"container":"LocalRoadUpdates-module--container--36ukX","topFont":"LocalRoadUpdates-module--topFont--2HLGt"};